import axios from "axios";
import { HOST } from "../../setting";

export const service = (id: number) => {
  return axios.get(`${HOST}/master/kit-qr/${id}/`);
};
